import React from "react";
import { withRouter } from "react-router-dom";
import SeoMeta from "./SeoMeta";
import generatedSeoMeta from "../../../generated/seoMeta";
import { withoutTrailingSlash } from "../../../Service/seoUrl";

const SITE_URL = "https://voorent.com";
const DEFAULT_IMAGE = "https://voorent.com/logo192.png";

const STATIC_ROUTE_META = {
  "/customization": {
    title: "Customised Furniture on Rent | Voorent",
    description:
      "Tell Voorent what you need and get furniture customised for your home, PG or co-living space, on rent.",
  },
  "/about-us": {
    title: "About Us | Voorent",
    description:
      "Learn more about Voorent, our mission, and how we make renting furniture and appliances easier in Delhi and Gurgaon.",
  },
  "/faq": {
    title: "Frequently Asked Questions | Voorent",
    description:
      "Find answers to common questions about renting furniture and appliances from Voorent.",
  },
  "/privacy-policy": {
    title: "Privacy Policy | Voorent",
    description:
      "Read the Voorent privacy policy covering data collection, processing, and customer privacy commitments.",
  },
  "/terms-conditions": {
    title: "Terms and Conditions | Voorent",
    description:
      "Review the terms and conditions for using Voorent and renting furniture and appliances.",
  },
  "/blogs/buying-vs-renting": {
    title: "Renting vs Buying: Which is the Better Option for You? | Voorent",
    description:
      "Compare renting vs buying furniture and appliances to choose the most practical option for your lifestyle and budget.",
    type: "article",
  },
  "/blogs/beginners-guide": {
    title: "Beginner's Guide to Renting Furniture | Voorent",
    description: "A practical beginner's guide to renting furniture for your home with confidence.",
    type: "article",
  },
  "/blogs/tips-for-renting-furniture": {
    title: "Tips for Renting Furniture | Voorent",
    description: "Explore useful tips to choose the right furniture on rent for your home and lifestyle.",
    type: "article",
  },
  "/blogs/furniture-rentals": {
    title: "Furniture Rentals Guide | Voorent",
    description: "Learn how furniture rentals work and how to pick the right items for your space.",
    type: "article",
  },
  "/blogs/aesthetic-ideas": {
    title: "Aesthetic Home Ideas with Rental Furniture | Voorent",
    description: "Discover aesthetic furniture ideas to elevate your home with affordable rental options.",
    type: "article",
  },
  "/blogs/upgrade-lifestyle": {
    title: "Upgrade Your Lifestyle with Rental Furniture | Voorent",
    description: "See how rental furniture and appliances can help you upgrade your home with flexibility.",
    type: "article",
  },
  "/blogs/seasonal-selfcare": {
    title: "Seasonal Self-Care Ideas for Your Home | Voorent",
    description: "Explore seasonal self-care ideas and home upgrades with convenient rental solutions.",
    type: "article",
  },
  "/blogs/types-of-wood": {
    title: "Types of Wood Used in Furniture | Voorent",
    description: "Understand common wood types used in furniture and what they mean for durability and style.",
    type: "article",
  },
  "/blogs/best-furniture-on-rent-in-gurgaon": {
    title: "Best Furniture on Rent in Gurgaon | Voorent",
    description: "Browse ideas and options for choosing the best furniture on rent in Gurgaon.",
    type: "article",
  },
  "/blogs/sofa-on-rent-in-gurgaon": {
    title: "Sofa on Rent in Gurgaon | Voorent",
    description: "Find stylish and affordable sofa rental options in Gurgaon with Voorent.",
    type: "article",
  },
  "/blogs/rented-appliances-in-gurgaon": {
    title: "Appliances on Rent in Gurgaon | Voorent",
    description: "Explore appliances on rent in Gurgaon for convenient and affordable living.",
    type: "article",
  },
  "/blogs/get-a-bed-on-rent-in-gurgaon": {
    title: "Get a Bed on Rent in Gurgaon | Voorent",
    description: "Discover practical bed rental options in Gurgaon for flexible and affordable living.",
    type: "article",
  },
  "/blogs/get-a-fridge-on-rent-in-gurgaon": {
    title: "Get a Fridge on Rent in Gurgaon | Voorent",
    description: "Find fridge rental options in Gurgaon to equip your home without large upfront costs.",
    type: "article",
  },
  "/blogs/study-table-on-rent-in-gurgaon": {
    title: "Study Table on Rent in Gurgaon | Voorent",
    description: "Explore study table rental options in Gurgaon for work, study, and compact spaces.",
    type: "article",
  },
  "/blogs/rent-a-chair-in-gurgaon": {
    title: "Rent a Chair in Gurgaon | Voorent",
    description: "Browse chair rental options in Gurgaon for homes, study spaces, and offices.",
    type: "article",
  },
};

const NOINDEX_PREFIXES = [
  "/account",
  "/cart",
  "/login",
  "/order",
  "/password",
  "/settings",
  "/user/add/address",
];

function GlobalRouteSeo({ location }) {
  // Apache serves prerendered pages at "/faq/"; metadata is keyed without the slash.
  const pathname = withoutTrailingSlash(location.pathname || "/");
  const staticMeta = generatedSeoMeta[pathname] || STATIC_ROUTE_META[pathname];
  const noindex = NOINDEX_PREFIXES.some((prefix) => pathname.startsWith(prefix));

  if (!staticMeta && !noindex) {
    return null;
  }

  return (
    <SeoMeta
      title={staticMeta ? staticMeta.title : "Voorent"}
      description={staticMeta ? staticMeta.description : "Voorent customer application pages"}
      canonical={`${SITE_URL}${pathname}`}
      image={DEFAULT_IMAGE}
      type={staticMeta && staticMeta.type ? staticMeta.type : "website"}
      noindex={noindex}
    />
  );
}

export default withRouter(GlobalRouteSeo);
